module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/footer-87f8f07602c409059f0e29ccb330640f.jpg";